import { useState, useEffect } from "react"
import handleError from "lib/handleError"

export async function getAlertData(pid: string | number) {
  try {
    const response = await fetch(`/api/alerts/${pid}`)
    const data = await response.json()
    return data
  } catch (e) {
    handleError(
      `Error fetching alert data, please check the [DBCA Alerts site](https://alerts.dbca.wa.gov.au/) for up-to-date info`,
      e
    )
    return null
  }
}

export default function useParksWA(pid: string | number) {
  const [parkData, setParkData] = useState(null)

  useEffect(() => {
    setParkData(null)
    getAlertData(pid).then((data) => setParkData(data))
  }, [pid])

  return parkData
}
